import { useEffect, useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { LinearProgress, Typography, AccordionSummary, Accordion, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { TablesProvider, TablesContext } from './TablesContext';
import { NavContext, UserContext } from '../../../contexts';
import { SapTableNames, LocalTableNames, ApplicationRoles } from '../../../../helpers';
import { SettingsTable, AccountGroupMappingEcc, AccountGroupMappingS4 } from './components';
import { DbType } from '../../../../helpers/Common';

const useStyles = makeStyles(theme => ({
    root: {
    },
    progress: {
        marginBottom: theme.spacing(2)
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        addBreadcrumbToken
    } = useContext(NavContext);

    const {
        isUserInRole
    } = useContext(UserContext);

    const {
        isLoadingTableDefs,
        getChoosenTableDefinitions,
        isLoadingAccGroupMappingsECC,
        getAccountGroupMappingsECC,
        isLoadingAccGroupMappingsS4,
        getAccountGroupMappingsS4,
    } = useContext(TablesContext)

    useEffect(() => {
        addBreadcrumbToken("App settings");
        getAccountGroupMappingsECC();
        getAccountGroupMappingsS4();
        getChoosenTableDefinitions(
            [
                SapTableNames.Countries,
                SapTableNames.SalesOrganizations,
                SapTableNames.Divisions,
                SapTableNames.DistributionChannels,
                SapTableNames.AccountGroups,
                SapTableNames.CustomerGroups,
                SapTableNames.CustomerGroups6,
                LocalTableNames.BusinessCategories
            ]
                .join()
        );
    }, []);

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(
            isLoadingTableDefs ||
            isLoadingAccGroupMappingsECC ||
            isLoadingAccGroupMappingsS4
        );
    }, [isLoadingTableDefs, isLoadingAccGroupMappingsECC, isLoadingAccGroupMappingsS4])

    return (
        <>
            {
                isLoading &&
                <LinearProgress
                    color="primary"
                    className={classes.progress}
                />
            }

            {
                isUserInRole(ApplicationRoles.Administrator) &&
                <Accordion disabled={isLoading}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography variant="h5">Local Settings ECC</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <SettingsTable
                            localAppSettings
                            dbType={DbType.ECC}
                        />
                    </AccordionDetails>
                </Accordion>
            }

            {
                isUserInRole(ApplicationRoles.Administrator) &&
                <Accordion disabled={isLoading}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography variant="h5">Local Settings S4</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <SettingsTable
                            localAppSettings
                            dbType={DbType.S4}
                        />
                    </AccordionDetails>
                </Accordion>
            }

            <Accordion disabled={isLoading}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography variant="h5">Sap Settings ECC</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <SettingsTable
                        sapAppSettings
                        dbType={DbType.ECC}
                    />
                </AccordionDetails>
            </Accordion>

            <Accordion disabled={isLoading}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography variant="h5">Sap Settings S4</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <SettingsTable
                        sapAppSettings
                        dbType={DbType.S4}
                    />
                </AccordionDetails>
            </Accordion>

            <Accordion disabled={isLoading}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                >
                    <Typography variant="h5">Account Group Mappings ECC</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AccountGroupMappingEcc />
                </AccordionDetails>
            </Accordion>

            {
                <Accordion disabled={isLoading}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header"
                    >
                        <Typography variant="h5">Account Group Mappings S4</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <AccountGroupMappingS4 />
                    </AccordionDetails>
                </Accordion>
            }
        </>
    );
};

export const SettingsPage = (props) =>
    <TablesProvider>
        <PageContent />
    </TablesProvider>;